<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h3>Zákazka</h3>" customHeader :customControls="`<span class='font-weight-bold'>Počet odoslaných formulárov: ${this.order.submittedFormsCount} celkovo, dnes: ${this.order.submittedFormsCountToday}</span>`">
          <b-row>
            <b-col class="order-details">
              <b-row>
                <b-col md="3">Názov</b-col>
                <b-col><strong>{{order.title}}</strong></b-col>
              </b-row>
              <b-row>
                <b-col md="3">Obstarávateľ:</b-col>
                <b-col><b>{{order.contractingAuthorityName}}</b></b-col>
              </b-row>
              <b-row v-if="order.contractPartTitle">
                <b-col md="3">Názov časti:</b-col>
                <b-col><b>{{order.contractPartTitle}}</b></b-col>
              </b-row>
              <b-row v-if="order.containsParts">
                <b-col md="3">Číslo časti:</b-col>
                <b-col><b>{{ order.lotNumber }}</b></b-col>
              </b-row>
              <b-row>
                <b-col md="3">Rámcová dohoda:</b-col>
                <b-col><b>{{ order.frameworkAgreement | formatBoolean }}</b></b-col>
              </b-row>
              <b-row>
                <b-col md="3">Časti:</b-col>
                <b-col><b>{{ order.containsParts | formatBoolean }}</b></b-col>
              </b-row>
              <b-row>
                <b-col md="3">Počet ponúk:</b-col>
                <b-col><b>{{order.numberOfTenders}}</b></b-col>
              </b-row>
              <b-row>
                <b-col md="3">PHZ:</b-col>
                <b-col v-if="order.estimatedValueAmount !== null">
                  <b>{{order.estimatedValueAmount | formatPrice}} {{ order.estimatedValueCurrency }} <span v-if="order.estimatedValueVatIncluded">s</span><span v-else>bez</span> DPH</b>
                </b-col>
                <b-col v-else><b>Nešpecifikované.</b></b-col>
              </b-row>
              <b-row v-if="brokenRules">
                <b-col md="3">Zistené nedostatky:</b-col>
                <b-col>
                  <b><span class="text-danger">{{ brokenRulesString }}</span></b>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="2" class="big-icon">
              <a :href="'https://www.uvo.gov.sk/vyhladavanie/vyhladavanie-zakaziek/dokumenty/' + order.uvoContractId" target="_blank"><i class="fa fa-file"></i>
                <br>
                Dokumenty ÚVO
              </a>
            </b-col>
          </b-row>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h3>Ponuky </h3>" bodyClass customHeader collapse>
          <div>
            <table class="table table-lg mb-0 offers-table">
              <thead>
                <tr class="text-muted">
                  <th>Dodávateľ</th>
                  <th>Cena</th>
                  <th>Mena</th>
                  <th><i style="cursor: pointer;" class="fa fa-sliders" @click.prevent="unitPriceToggle"></i> Jedn.&nbsp;cena</th>
                  <th><i style="cursor: pointer;" class="fa fa-sliders" @click.prevent="vatToggle"></i> DPH</th>
                  <th>%</th>
                  <th><i style="cursor: pointer;" class="fa fa-sliders" @click.prevent="excludedToggle"></i> Vylúčená</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(offer, index) in offers">
                  <tr :key="`offer-${index}-offer`">
                    <td :class="{'field-invalid': !offer.mainContractor.valid}">
                      <contractor-select v-model="offer.mainContractor.value" />
                    </td>
                    <td :class="{'field-invalid': !offer.amount.valid}">
                      <b-form-input :id="`offer-amount-${index}`" style="width: 125px;" v-model="offer.amount.value" type="text" />
                      <b v-if="offer.amount.parsedValue !== null">{{ offer.amount.parsedValue | formatPrice}} {{offer.currency.value}}</b>
                    </td>
                    <td :class="{'field-invalid': !offer.currency.valid}">
                      <b-form-input :id="`offer-currency-${index}`" style="width: 75px;" v-model="offer.currency.value" type="text" />
                    </td>
                    <td>
                      <b-form-radio-group :id="`offer-is-unit-price-${index}`" v-model="offer.isUnitPrice" required>
                        <b-form-radio name="vat-radios" :value="true">Áno</b-form-radio><br />
                        <b-form-radio name="vat-radios" :value="false">Nie</b-form-radio>
                      </b-form-radio-group>
                    </td>
                    <td :class="{'field-invalid': !offer.vatIncluded.valid}">
                      <b-form-radio-group :id="`offer-vat-included-${index}`" v-model="offer.vatIncluded.value" required>
                        <b-form-radio name="vat-radios" :value="true">S DPH</b-form-radio>
                        <b-form-radio name="vat-radios" :value="false">Bez DPH</b-form-radio>
                      </b-form-radio-group>
                    </td>
                    <td :class="{'field-invalid': !offer.vatRate.valid}" style="width: 100px;">
                      <b-form-input v-if="offer.vatIncluded.value" :id="`offer-vat-${index}`" style="width: 75px;" v-model="offer.vatRate.value" type="number" min="0" max="100" step="1" />
                    </td>
                    <td :class="{'field-invalid': !offer.excluded.valid}">
                      <b-form-radio-group :id="`offer-excluded-${index}`" v-model="offer.excluded.value" required>
                        <b-form-radio name="excluded-radios" :value="true">Áno</b-form-radio>
                        <b-form-radio name="excluded-radios" :value="false">Nie</b-form-radio>
                      </b-form-radio-group>
                    </td>
                    <td style="width: 180px;">
                      <b-button variant="success" size="xs" @click.prevent="addGroupContractor(index)">Pridať člena skupiny</b-button>&nbsp;<b-button variant="danger" size="xs" @click.prevent="removeOffer(index)">X</b-button>
                    </td>
                  </tr>
                  <template v-if="offer.isGroup">
                    <tr v-for="(contractor, contractorIndex) in offer.contractors" :key="`${index}-${contractorIndex}`" class="group-contractor">
                      <td><offer-contractor :contractor="contractor" @setContractor="setContractor($event, index, contractorIndex)"/></td>
                      <td><b-button variant="danger" size="xs" @click.prevent="removeGroupContractor(index, contractorIndex)">X</b-button></td>
                      <td colspan="5"></td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
          <div class="text-right">
            <b-button variant="success" @click.prevent="addNewOffer()">Pridať ponuku</b-button>
          </div>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget customHeader>
          <b-row class="justify-content-md-center">
            <b-col md="1"></b-col>
            <b-col md="2" class="big-icon">
              <a href="" @click.prevent="reportBug()" style="color: #f22d2d;"><i class="fa fa-warning big-icon"></i>
                <br>
                Nahlásiť chybnú zákazku
              </a>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="2" class="big-icon">
              <a href="" @click.prevent="saveOrder()" style="color: #3abf94;"><i class="fa fa-share big-icon"></i>
                <br>
                Odoslať zákazku
              </a>
            </b-col>
            <b-col md="1"></b-col>
          </b-row>
        </Widget>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="12">
        <Widget title="<h3>Dokumenty</h3>" bodyClass customHeader collapse>
          <documents-widget :documents="order.documents"></documents-widget>
        </Widget>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import Widget from "@/components/Widget/Widget"
import DocumentsWidget from "@/components/Custom/DocumentsWidget"
import AddContractorWIndow from './AddContractorWIndow'
import ContractorSelect from './ContractorSelect'
import OfferContractor from './OfferContractor'

let formatNumber = require('format-number');
let formatPrice = formatNumber({ integerSeparator: ' ', decimalsSeparator: ' ', decimal: ',' })

export default {
  name: "Formular",
  components: { Widget, DocumentsWidget, OfferContractor, ContractorSelect },
  data() {
    return {
      order: {
        documents: []
      },
      offers: [],
      brokenRules: null,
      token: this.$route.params.token
    };
  },
  watch: {
    offers: {
      handler (offers) {
        this.validateOffers(offers)
      },
      deep: true
    }
  },
  computed: {
    brokenRulesString () {
      const rules = {
        1: 'Víťazná cena podľa vestníka sa nezhoduje so žiadnou hodnotou (tu pozor na dph)',
        2: 'Počet uchádzačov podľa vestníka sa nezhoduje s počtom uchádzačov vo formulároch',
        3: 'Viac uchádzačov má rovnakú cenu (vo formulároch)',
        4: 'Víťaz podľa vestníka sa nezhoduje s najnižšou cenou vo formulároch (platí len v prípade ak je kritérium na výber len cena), pričom najnižšia cena vo formulároch nemá pridelený atribút „vylúčená“',
        5: 'Podozrenie na jednotkovu cenu, skontrolujte spravnost oznacenia jednotkovej ceny / ceny celkom',
        6: 'Podozrenie na preklep v cene, je nevyhnutne skontrolovat vsetky predlozene ponuky',
        7: 'Podozrenie na preklep v jednotkovej cene, finalna cena (+/- DPH) nie je celociselnym nasobkom jednotkovej ceny'
      }
      return this.brokenRules ? this.brokenRules.map(rule => rules[rule]).join(', ') : ''
    }
  },
  methods: {
    normalizePrice (price) {
      price = price.replace(/\s/g, "")
      let segments = [...price.matchAll(/[0-9]+/g)]
      if (!segments.length) {
        return null;
      }
      let isDecimal = (segments.length > 1 && segments[segments.length-1][0].length < 3) || (price[segments[segments.length-1].index - 1] === ',')
      if (isDecimal) {
        let decimal = segments.pop()
        return Number(segments.join('') + '.' + decimal)
      } else {
        return Number(segments.join(''))
      }
    },
    addNewOffer () {
      let offer = {
        mainContractor: {
          value: null,
          valid: false
        },
        contractors: [],
        isGroup: false,
        isUnitPrice: false,
        excluded: {
          value: null,
          valid: false
        },
        amount: {
          value: '',
          valid: false,
          parsedValue: null
        },
        vatIncluded: {
          value: null,
          valid: false
        },
        vatRate: {
            value: '20',
            valid: false
        },
        currency: {
            value: 'EUR',
            valid: true
        }
      }

      this.offers.push(offer)
    },
    removeOffer (offerIndex) {
      this.offers.splice(offerIndex, 1);
    },
    selectMainContractor (offerIndex) {
      let vm = this
      this.$vuedals.open({
        name: 'add-supplier-window',
        title: 'Vyber dodávateľa',
        props: {
          offerIndex: offerIndex,
          isMainContractor: true,
          isGroup: this.offers[offerIndex].isGroup
        },
        component: AddContractorWIndow,
        onClose (data) {
          vm.offers[data.offerIndex].mainContractor.value = data.contractor;
          vm.offers[data.offerIndex].mainContractor.valid = true
        }
      });
    },
    addGroupContractor (offerIndex) {
      let vm = this
      this.$vuedals.open({
          name: 'add-supplier-window',
          title: 'Vyber dodávateľa',
          props: {
            offerIndex: offerIndex,
            isMainContractor: false,
            isGroup: true
          },
          component: AddContractorWIndow,
          onClose (data) {
            vm.offers[data.offerIndex].contractors.push(data.contractor);
            vm.offers[data.offerIndex].isGroup = true
          }
      });
    },
    removeGroupContractor (offerIndex, contractorIndex) {
      this.offers[offerIndex].contractors.splice(contractorIndex, 1);
      this.offers[offerIndex].isGroup = !!this.offers[offerIndex].contractors.length
    },
    validateOrder () {
      let valid = false
      if (this.offers.length) {
        valid = this.validateOffers(this.offers)
      } else {
        Swal.fire({
          type: 'error',
          text: 'Nie je možné odoslať zákazku bez ponúk!',
        })
      }
      return valid;
    },
    validateOffers (offers) {
      return offers.map(this.validateOffer).reduce((value, accumulator) => value && accumulator , true)
    },
    validateOffer (offer) {
      let valid = true

      offer.mainContractor.valid = !!offer.mainContractor.value
      valid = valid && offer.mainContractor.valid

      offer.amount.parsedValue = this.normalizePrice(offer.amount.value)
      offer.amount.valid = offer.amount.parsedValue !== null || offer.excluded.value
      valid = valid && offer.amount.valid
      
      offer.currency.valid = !!offer.currency.value.length || !offer.amount.value.length
      valid = valid && offer.currency.valid

      offer.vatIncluded.valid = !(offer.vatIncluded.value == null) || !offer.amount.value.length
      valid = valid && offer.vatIncluded.valid

      if (offer.vatIncluded.value) {
        if (!offer.vatRate.value.length) {
          offer.vatRate.valid = false
          valid = valid && offer.vatRate.valid
        } else {
          offer.vatRate.valid = true
        }
      } else {
        offer.vatRate.value = '20'
        offer.vatRate.valid = true
      }

      offer.excluded.valid = offer.excluded.value == null ? false : true;
      valid = valid && offer.excluded.valid

      return valid;
    },
    getOfferData (offer) {
      let response = {
        isGroup: offer.isGroup,
        contractors: [],
        amount: offer.amount.parsedValue,
        currency: offer.amount.value.length ? offer.currency.value : null,
        vatIncluded: offer.amount.value.length ? offer.vatIncluded.value : null,
        vatRate: offer.vatIncluded.value ? Number(offer.vatRate.value.replace(/\s+/g, '').replace(',', '.')) : null,
        excluded: offer.excluded.value,
        isUnitPrice: offer.isUnitPrice
      }

      if (offer.isGroup) {
        response.contractors = offer.contractors.map((contractor) => {
          return {
            cin: contractor.foreignCin || contractor.organization.cin,
            country: contractor.country
          }
        })
      }
      
      if (offer.mainContractor.value) {
        let mainContractor = {
          cin: offer.mainContractor.value.foreignCin || offer.mainContractor.value.organization.cin,
          country: offer.mainContractor.value.country
        }
        response.contractors.push(mainContractor)
      }   

      return response
    },
    async saveOrder () {
      
      if (!this.validateOrder()) {
        return
      }

      let { value: result } = await Swal.fire({
        type: 'question',
        text: 'Ste si istý, že chcete odoslať zákazku ?',
        showCancelButton: true,
        cancelButtonText: 'Zrušiť'
      })
      if (result) {

        let request = {
          contractId: this.order.id,
          token: this.token,
          flag: 1,
          note: null,
          offers: this.offers.map(this.getOfferData)
        }

        let response = await this.$transparexHttp.put('/awarded-contracts', request)
        
        if (response.status !== 200) {
          Swal.fire({
            type: 'error',
            text: 'Nepodarilo sa odoslať zákazku',
          })
          return;
        }

        let { value: result2 } = await Swal.fire({
          type: 'question',
          text: 'Načítať ďalšiu zákazku ?',
          showCancelButton: true,
          cancelButtonText: 'Zrušiť'
        })

        if (result2) {
          this.offers = []
          this.getOrder()
        } else {
          this.$router.push({ name: 'DashboardPage', params: { token: this.token }})
        }
      }
    },
    async reportBug () {
      let { value: text } = await Swal.fire({
        type: 'error',
        input: 'textarea',
        inputPlaceholder: 'Popis chyby...',
        showCancelButton: true,
        cancelButtonText: 'Zrušiť'
      })
      if (text) {
        const message = this.base64EncodeUnicode(JSON.stringify({ offers: this.offers.map(this.getOfferData)}))
        const request = {
          contractId: this.order.id,
          token: this.token,
          flag: 2,
          note: text + '###' + message,
          offers: []
        }
        let response = await this.$transparexHttp.put('/awarded-contracts', request)
        if (response.status === 200) {
          this.offers = []
          this.getOrder()
        }
      }
    },
    async getOrder () {
      Swal.fire({
        onBeforeOpen: () => {
          Swal.showLoading()
        }
      });
      let response = await this.$transparexHttp.post('/awarded-contracts', { token: this.token })
      Swal.close();
      if (response.status === 200) {
        Object.assign(this.order, response.data)
        this.brokenRules = []
        setTimeout(function(){document.getElementsByClassName('root')[0].scrollIntoView()}, 250)
        for (var i = 0; i < this.order.numberOfTenders; i++) {
          this.addNewOffer()
        }
        if (this.order.shortDescription !== null) {
          this.decodeObject()
        } 
      } else {
        await Swal.fire({
          type: 'error',
          text: 'Nepodarilo sa načítať zákazku',
        })
        let token = this.token
        this.$router.push({ name: 'DashboardPage', params: { token }})
      }
    },
    vatToggle() {
      this.offers.forEach(offer => {
        if (offer.vatIncluded.value !== null) {
          offer.vatIncluded.value = !offer.vatIncluded.value
        } else {
          offer.vatIncluded.value = true
        }
      })
    },
    unitPriceToggle() {
      this.offers.forEach(offer => {
        if (offer.isUnitPrice !== null) {
          offer.isUnitPrice = !offer.isUnitPrice
        } else {
          offer.isUnitPrice = false
        }
      })
    },
    excludedToggle() {
      this.offers.forEach(offer => {
        if (offer.excluded.value !== null) {
          offer.excluded.value = !offer.excluded.value
        } else {
          offer.excluded.value = false
        }
      })
    },
    base64EncodeUnicode(str) {
      let utf8Bytes = encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1)
      })
      return btoa(utf8Bytes)
    },
    decodeObject () {
      let string = atob(this.order.shortDescription)
      let formularObject = JSON.parse(string)
      let offers = formularObject.offers
      this.offers = []
      offers.forEach((offer, index) => {
        this.addNewOffer()
        let offerObject = {
          mainContractor: { value:  offer.contractors.pop() || null },
          contractors: offer.contractors,
          isGroup: offer.is_group,
          isUnitPrice: offer.is_unit_price || false,
          excluded: { value: offer.excluded },
          amount: { value: String(offer.amount || '') },
          vatIncluded: { value: offer.vat_included },
          vatRate: { value: String(offer.vat_rate) },
          currency: { value: offer.currency || 'EUR' }
        }
        //tagging contractors for rpoSearchBox
        if (offerObject.mainContractor.value) {
          offerObject.mainContractor.value.fetched = true
        }
        //tagging contractors
        offerObject.contractors.forEach(contractor => contractor.fetched = true)

        Object.assign(this.offers[index], offerObject)
      })
      this.brokenRules = formularObject.broken_rules
      //this.fetchGroupContractors()
    },
    /* fetchGroupContractors () {
      this.offers.forEach(offer => {
        if (offer.isGroup) {
          offer.contractors.forEach(contractor => {
            await ()
          })
        }
      })
    },
    async fetchGroupContractor (cin) {
      const { data } = await this.$elasticHttp.post('/dev_rpo_org_search', searchByCin(cin))
      
    } */
    setContractor(payload, offerIndex, contractorIndex) {
      this.offers[offerIndex].contractors[contractorIndex] = {
        country: payload.country,
        foreignCin: null,
        organization: payload.organization
      }
    }
  },
  created () {
    this.getOrder()
  },
  filters: {
    formatPrice: formatPrice,
    formatBoolean (value) {
      if (value === null) {
        return 'Neznáme';
      } else {
        return value ? 'Áno' : 'Nie';
      }
    }
  }
}

</script>
<style src="./Formular.scss" lang="scss" scoped />